import { Link, useLocation } from 'react-router-dom';
import { useLang } from '../App';
import { UI } from '../content';

export default function Nav() {
  const { lang, setLang } = useLang();
  const location = useLocation();
  const t = UI[lang].nav;

  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/" className="nav-name">Adam Elaoumari</Link>

        <div className="nav-right">
          <ul className="nav-links">
            <li>
              <Link
                to="/"
                className={`nav-link${location.pathname === '/' ? ' active' : ''}`}
              >
                {t.home}
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                className={`nav-link${location.pathname === '/projects' ? ' active' : ''}`}
              >
                {t.projects}
              </Link>
            </li>
          </ul>

          <div className="lang-switch">
            <button
              className={`lang-btn${lang === 'en' ? ' active' : ''}`}
              onClick={() => setLang('en')}
            >
              EN
            </button>
            <span className="lang-sep">/</span>
            <button
              className={`lang-btn${lang === 'fr' ? ' active' : ''}`}
              onClick={() => setLang('fr')}
            >
              FR
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
